import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import Konami from "react-konami-code";
import { useStoreRehydrated, useStoreState } from "ezStore";

import Login from "../view/login/Login";
import AuthorizeApplication from "../view/login/AuthorizeApplication";
import Logout from "../view/login/Logout";
import PageNotFoundIndex from "../view/pagenotfound/index";

import PrivateRoutes from "components/routes/PrivateRoutes";
import AsyncLoadingComponent from "components/AsyncLoadingComponent";
import LoginRoute from "components/routes/LoginRoute";
import PrivateRoute from "components/routes/PrivateRoute";

import "../styling/custom.scss";

const Application = () => {
	const isRehydrated = useStoreRehydrated();
	const { session } = useStoreState(store => store);

	const userInfoLoaded = !session.user?.username || !!session.user.properties;
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	return userInfoLoaded && isRehydrated ? (
		<AsyncLoadingComponent>
			<BrowserRouter>
				<Routes>
					<Route
						path="/view/login"
						element={(
							<LoginRoute>
								<Login />
							</LoginRoute>
						)}
					/>

					<Route
						path="/view/authorize"
						element={(
							<AuthorizeApplication />
						)}
					/>

					<Route
						path="/view/logout"
						element={(
							<PrivateRoute>
								<Logout />
							</PrivateRoute>
						)}
					/>

					<Route
						path="/view/error/404"
						element={<PageNotFoundIndex />}
					/>

					<Route
						path="/view/*"
						element={(
							<PrivateRoute>
								<PrivateRoutes />
							</PrivateRoute>
						)}
					/>

					<Route
						path="/"
						element={<Navigate to="/view/" />}
					/>
				</Routes>
			</BrowserRouter>

			<Konami code={[ 38, 38, 40, 40, 37, 39, 37, 39 ]} action={() => window.open("/view/admin?tab=settings", "_blank")} /> {/* AKA ↑ ↑ ↓ ↓ ← → ← → */}
			<Konami code={[ 17, 16, 65, 73, 83 ]} action={() => window.open("/view/maps/simulator?tab=simulator", "_blank")} /> {/* AKA ctrl shift a i s */}
		</AsyncLoadingComponent>
	) : <div />;
};

export default Application;
